export default "__VITE_ASSET__BDnCh51K__"